module.exports = __webpack_public_path__ + "f8534d3c93ece47c933b822703511be9.png";